export const SWITCH_GLOBAL_LOADER = "SWITCH_GLOBAL_LOADER";
export interface SwitchGlobalLoader {
    type: typeof SWITCH_GLOBAL_LOADER;
    payload: boolean;
}

export type GlobalLoadingActions =
    | SwitchGlobalLoader
